var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"type":"text","label":_vm.label,"error-messages":_vm.errors,"hide-details":!_vm.v.$error,"outlined":"","disabled":_vm.disabled,"rows":"4"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/TextareaComponent.vue?vue&type=template&id=5bdf2929
// module id = null
// module chunks = 